module.exports = __webpack_public_path__ + "static/reflection-276c45e4b48ee9d38b8e2226ea4404da.png";